import { useQuery } from '@tanstack/react-query';
import { getTransferAudio } from '../../api/WorkflowServiceAPI';
import { queryKeys } from '../queryKeys';

export const useGetTransferAudio = (workflowId = '', enabled = false) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.transferAudio(workflowId),
        queryFn: () => getTransferAudio(workflowId),
        enabled: !!workflowId && enabled,
        // A 404 is the normal "no clip" answer, not a transient failure.
        retry: false,
        // The provider refetches on every mount, and this one costs up to 2 MB.
        // Upload and delete both evict the key, so nothing else can go stale.
        staleTime: Infinity,
    });

    return {
        transferAudio: data,
        isLoadingTransferAudio: isLoading,
        ...rest,
    };
};
